<template>
  <div class="recruit">
    <div class="page-width">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/new-img/driver/tit-l.png" width="34" />
          </span>美菜合作司机招募流程
          <span class="tit-r">
            <img src="@/assets/images/new-img/driver/tit-r.png" width="35" />
          </span>
        </h2>
      </div>
      <ul>
        <li class="colour-a">
          <span>提交报名信息</span>
          <em>
            <img src="@/assets/images/new-img/driver/recruit-icon-1.png" width="52" />
          </em>
        </li>
        <div class="arrow"></div>
        <li class="colour-b">
          <span>沟通洽谈合作意向</span>
          <em>
            <img src="@/assets/images/new-img/driver/recruit-icon-2.png" width="52" />
          </em>
        </li>
        <div class="arrow"></div>
        <li class="colour-c">
          <span>确定合作条件</span>
          <em>
            <img src="@/assets/images/new-img/driver/recruit-icon-3.png" width="52" />
          </em>
        </li>
        <div class="arrow"></div>
        <!-- <li class="colour-d">
          <span class="pad-t">实习3天后<br />正式上岗</span>
          <em>
            <img src="@/assets/images/new-img/driver/recruit-icon-4.png" width="52" />
          </em>
        </li> -->
        <!-- <div class="arrow"></div> -->
        <li class="colour-e">
          <span class="pad-t">
            成为合作司机
          </span>
          <em>
            <img src="@/assets/images/new-img/driver/recruit-icon-5.png" width="52" />
          </em>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "recruit",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.recruit {
  padding: 75px 0;
  .title h2 {
    font-size: 34px;
    position: relative;
    width: 370px;
    margin: 0 auto;
    text-align: center;
  }
  ul {
    height: 180px;
    width: 1020px;
    margin: 40px auto 0;
    li {
      border: 1px dashed #c0c0c0;
      background: #fff;
      width: 156px;
      height: 140px;
      float: left;
      border-radius: 4px;
      position: relative;
      text-align: center;
      font-size: 18px;
      span {
        padding-top: 60px;
        display: block;
        line-height: 1.6;
      }
      span.pad-t {
        padding-top: 48px;
      }
      em {
        position: absolute;
        top: -25px;
        left: 50%;
        margin-left: -26px;
      }
    }
    .arrow {
      width: 60px;
      float: left;
      height: 140px;
      background: url(~@/assets/images/new-img/driver/arrow-li.png) no-repeat center;
      background-size: 18px 27px;
    }
    li.colour-a {
      border-color: #f76064;
    }
    li.colour-b {
      border-color: #56cadc;
    }
    li.colour-c {
      border-color: #f6a623;
    }
    li.colour-d {
      border-color: #7b82eb;
    }
    li.colour-e {
      border-color: #ea4789;
    }
  }
}
</style>
